/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, group: NonNullable<unknown> }} Assistant_Activity_DeletedInputs */



/**
* | output |
* | --- |
* | "Deleted {count} events in {group}" |
*
* @param {Assistant_Activity_DeletedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_activity_deleted = /** @type {((inputs: Assistant_Activity_DeletedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Activity_DeletedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Événements ${i?.count} supprimés dans ${i?.group}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count}-Ereignisse in ${i?.group} gelöscht`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Eventi ${i?.count} eliminati in ${i?.group}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Удалены события ${i?.count} в ${i?.group}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Se eliminaron los eventos ${i?.count} en ${i?.group}.`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`已删除 ${i?.group} 中的 ${i?.count} 事件`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.group} 内の ${i?.count} イベントを削除しました`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.group} में ${i?.count} इवेंट हटा दिए गए`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Eventos ${i?.count} excluídos em ${i?.group}`)
	return /** @type {LocalizedString} */ (`Deleted ${i?.count} events in ${i?.group}`)
});